<div
  class="column px-8 py-4 bg-blue-50 rounded-lg"
  appDroppable
  appDroppableHoverClass="bg-blue-100"
  [appDroppablePredicate]="dndPredicate"
  [appDroppableNoReposition]="true"
  [appDroppableHoverOnly]="true"
  [class.large]="appearance === 'board-large'"
  [class.medium]="appearance === 'board-medium'"
  [class.small]="appearance === 'board-small'"
  [class.collapsed]="collapsed"
>
  <div class="column-marker" [style.background-color]="column.color"></div>

  <div
    class="items-center column-heading gap-6 pr-22 before:content-[''] before:w-[3px] before:h-10 before:rounded-[2px] before:shrink-0 before:bg-[var(--column-accent)]"
    [style.--column-accent]="column.color"
  >
    <div class="flex items-center gap-4 w-content">
      <input
        #titleInput
        class="column-heading-title text-base font-semibold !flex-none [field-sizing:content] min-w-[1ch] max-w-full"
        (blur)="handleBlur()"
        (keydown.enter)="titleInput.blur()"
        placeholder="Untitled"
        [readonly]="section && column.id !== 'temp'"
        [formControl]="columnForm.controls.title"
      />

      @if (!section && tasksCount && columnForm.controls.title.value) {
        <div class="column-heading-task-count">
          {{ tasksCount }}
        </div>
      }
    </div>

    @if (section) {
      <div
        class="bg-primary-400 h-10 w-fit max-w-[70px] rounded text-white flex items-center justify-center ml-auto px-2"
      >
        <span class="truncate text-xs font-bold">{{ section?.title || 'Section ' + sectionPosition }}</span>
      </div>
    }
  </div>

  @if (!collapsed && column.id) {
    <app-button2
      class="column-collapse-dots"
      appearance="secondary-ghost"
      size="s"
      matTooltip="More options"
      stchPopoverTrigger="click"
      [appProjectBoardColumnContextMenu]="column"
      [appProjectBoardColumnContextMenuSection]="section"
    >
      <app-icon name="sapphire-ellipsis" />
    </app-button2>
  }

  @if (column.id) {
    <app-button2 class="column-collapse-icon" appearance="secondary-ghost" size="s" (click)="collapse()">
      <app-icon name="chevron-down" />
    </app-button2>
  }

  <div class="column-collapsed-title text-base font-semibold">{{ column.title }}</div>

  <div class="column-content" [class.default-row]="!section">
    <app-board-task
      *dndNestedFor="
        let task of tasks;
        let index = index;
        let position = position;
        positionKey: 'boardPosition';
        maxDepth: 0;
        droppableZIndex: 1;
        changes: tasksChanges;
        predicate: dndPredicate;
        preserveDraggedVisibility: true;
        topBuffer: true
      "
      [task]="task"
      [index]="index"
      [position]="position"
    />

    @if (!quickTask) {
      <div
        class="column-content-new-task text-sm font-medium text-secondary-850 gap-1 whitespace-nowrap"
        [class.opacity-50]="!canAddTask"
        [class.pointer-events-none]="!canAddTask"
        (click)="handleNewTask()"
        appDroppable
        appDroppableHoverClass="rounded-md outline-4 outline-dashed outline-blue-200 outline-offset-[-4px]"
        [appDroppableDisabled]="!canAddTask"
        [appDroppablePredicate]="newTaskDndPredicate"
        [appDroppableZIndex]="10"
        (appDroppableDrop)="handleNewTaskDrop($event)"
      >
        <app-icon name="plus" size="l" />
        Add a new task
      </div>
    }

    @if (quickTask) {
      <app-task-quick-form
            #quickForm
        class="task-quick-form"
        [showMore]="true"
        [task]="quickTask"
        (close)="handleQuickFormClose()"
        (save)="handleQuickFormSave($event, quickForm)"
        (more)="handleQuickFormMore($event)"
        (afterSave)="close()"
      />
    }
  </div>
</div>
